module.exports = __webpack_public_path__ + "static/media/creative-commons-by.30a79c37.svg";